import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Hexagon, Gavel, Tag } from "lucide-react";

export default function NFTCard({ asset }) {
  const isImage = (asset.file_type || "").startsWith("image/");
  const isVideo = (asset.file_type || "").startsWith("video/");
  return (
    <Link
      to={`/asset/${asset.id}`}
      data-testid={`nft-card-${asset.id}`}
      className="card-window p-0 block no-underline text-black hover:no-underline"
      style={{ textDecoration: "none" }}
    >
      <div className="window-title">
        <span className="text-xs truncate">{asset.title}.nft</span>
        <span className="text-[10px] font-mono">_ □ X</span>
      </div>
      <div className="p-2">
        <div className="relative aspect-square bevel-in bg-white overflow-hidden">
          {isImage ? (
            <img src={fileUrl(asset.file_path)} alt={asset.title} className="w-full h-full object-cover" />
          ) : isVideo ? (
            <video src={fileUrl(asset.file_path)} className="w-full h-full object-cover" muted loop autoPlay playsInline />
          ) : (
            <div className="w-full h-full grid place-items-center checkers">
              <div className="text-center bg-white border-2 border-black p-3">
                <Hexagon size={32} className="mx-auto text-retro-hot" strokeWidth={2} />
                <div className="mt-2 text-[10px] font-mono uppercase">{(asset.original_filename || "").split(".").pop()}</div>
              </div>
            </div>
          )}
          <div className="absolute top-2 left-2 flex gap-1">
            <span className="tag-90">{asset.contract_type}</span>
            {asset.creator_role === "teacher" && (
              <span className="tag-90 tag-90-hot">LESSON</span>
            )}
          </div>
          {asset.list_type === "auction" && (
            <div className="absolute top-2 right-2 tag-90 tag-90-cool flex items-center gap-1">
              <Gavel size={10} /> AUCTION
            </div>
          )}
        </div>
        <div className="mt-2 px-1">
          <div className="font-display text-base truncate font-bold">{asset.title}</div>
          <div className="text-xs font-mono truncate">by <span className="text-retro-link underline">{asset.creator_name}</span></div>
          <div className="flex items-center justify-between mt-2 pt-2 border-t-2 border-dashed border-black/30">
            <div className="text-[10px] uppercase font-mono">{asset.list_type === "auction" ? "Top Bid" : "Price"}</div>
            <div className="font-mono text-sm font-bold flex items-center gap-1">
              <Tag size={11} className="text-retro-hot" />
              {asset.list_type === "auction"
                ? `${asset.highest_bid_eth ?? 0} ETH`
                : asset.price_eth != null
                ? `${asset.price_eth} ETH`
                : "—"}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
